module.exports = __webpack_public_path__ + "static/media/shape0_7.283b130b.obj";